export const maptilerStyle = {
  version: 8,
  name: 'maptiler',
  sources: {
    maptiler: {
      type: 'raster',
      tiles: [
        `https://api.maptiler.com/maps/openstreetmap/{z}/{x}/{y}.jpg?key=${process.env.VUE_APP_MAPTILER_KEY}`,
      ],
      attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
    },
  },
  layers: [
    {
      id: 'maptiler',
      type: 'raster',
      source: 'maptiler',
    },
  ],
};

export const cadastreStyle = {
  version: 8,
  name: 'cadastre',
  sources: {
    cadastre: {
      type: 'raster',
      tiles: [
        `https://wxs.ign.fr/${process.env.VUE_APP_PUBLIC_IGN_KEY}/geoportail/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=CADASTRALPARCELS.PARCELLAIRE_EXPRESS&STYLE=normal&FORMAT=image/png&TILEMATRIXSET=PM&tilecol={x}&tilerow={y}&tilematrix={z}`,
      ],
      attribution: 'IGN',
    },
  },
  layers: [
    {
      id: 'cadastre',
      type: 'raster',
      source: 'cadastre',
    },
  ],
};

export const mapStyle = {
  version: 8,
  name: 'map',
  sources: {
    plan: {
      type: 'raster',
      tiles: [
        `https://wxs.ign.fr/${process.env.VUE_APP_CLIENT_IGN_KEY}/geoportail/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=GEOGRAPHICALGRIDSYSTEMS.MAPS&STYLE=normal&FORMAT=image/jpeg&TILEMATRIXSET=PM&tilecol={x}&tilerow={y}&tilematrix={z}`,
      ],
      attribution: 'IGN',
    },
  },
  layers: [
    {
      id: 'plan',
      type: 'raster',
      source: 'plan',
    },
  ],
};

export const orthoStyle = {
  version: 8,
  name: 'ortho',
  sources: {
    ortho: {
      type: 'raster',
      tiles: [
        `https://wxs.ign.fr/${process.env.VUE_APP_PUBLIC_IGN_KEY}/geoportail/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&STYLE=normal&FORMAT=image/jpeg&TILEMATRIXSET=PM&tilecol={x}&tilerow={y}&tilematrix={z}`,
      ],
      attribution: 'IGN',
    },
  },
  layers: [
    {
      id: 'ortho',
      type: 'raster',
      source: 'ortho',
    },
  ],
};

export const planStyle = {
  version: 8,
  name: 'plan',
  sources: {
    plan: {
      type: 'raster',
      tiles: [
        `https://wxs.ign.fr/${process.env.VUE_APP_PUBLIC_IGN_KEY}/geoportail/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&FORMAT=image/png&TILEMATRIXSET=PM&tilecol={x}&tilerow={y}&tilematrix={z}`,
      ],
      attribution: 'IGN',
    },
  },
  layers: [
    {
      id: 'plan',
      type: 'raster',
      source: 'plan',
    },
  ],
};
